import { Switch } from '@material-ui/core/'
import { rem, shade, tint } from 'polished'
import styled from 'styled-components'

import { type IToggleProps } from '../Toggle'

export const ToggleStyled = styled((props: IToggleProps) => {
  return (
    <Switch
      {...props}
      role='switch'
      aria-checked={props.checked ? 'true' : 'false'}
      classes={{
        track: 'toggleBar',
        checked: 'toggleChecked',
        disabled: 'toggleDisabled',
        thumb: 'toggleIcon',
        switchBase: 'toggleIconBase',
      }}
      disableRipple={true}
    />
  )
})`
  .toggleIcon {
    width: ${(props) => props.theme.typography.pxToRem(30)};
    height: ${(props) => props.theme.typography.pxToRem(30)};
    transition: transform 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
    background-color: ${(props) => props.theme.palette.background.default};
    border: 2px solid
      ${(props) => shade(0.1, props.theme.colors.content.border)};
    box-shadow: ${(props) => props.theme.shadows[1]};
  }
  .toggleIconBase {
    width: ${(props) => props.theme.typography.pxToRem(72)};
    height: ${(props) => props.theme.typography.pxToRem(38)};
    padding: 0;
    justify-content: flex-start;
    &:hover {
      background-color: transparent;
    }
    &.toggleChecked {
      transform: translateX(0);
      .toggleIcon {
        transform: ${(props) =>
          `translateX(${props.theme.typography.pxToRem(42)})`};
      }
      &:hover {
        background-color: transparent;
      }
      &::before {
        content: '${(props) => props.yes}';
        left: ${(props) => props.theme.typography.pxToRem(16)};
        color: ${(props) => props.theme.colors.text.inverse};
      }
    }
    &.toggleDisabled {
      .toggleIcon {
        box-shadow: ${(props) => props.theme.shadows[0]};
        border-color: ${(props) =>
          shade(0.1, props.theme.colors.content.border)};
        background-color: ${(props) =>
          tint(0.3, props.theme.colors.content.border)};
      }

      &::before {
        color: ${(props) => props.theme.colors.text.disabled};
      }
    }

    &::before {
      font-weight: ${(props) => props.theme.fontWeights.bold};
      font-size: ${(props) => props.theme.typography.pxToRem(12)};
      text-transform: uppercase;
      content: '${(props) => props.no}';
      color: ${(props) => {
        if (props.disabled) return tint(0.3, props.theme.palette.text.primary)
        return props.checked
          ? props.theme.colors.text.inverse
          : props.theme.palette.text.primary
      }};
      color: ${(props) => props.theme.colors.text.primary};
      position: absolute;
      left: ${(props) => props.theme.typography.pxToRem(36)};
    }
  }
  .toggleIconChecked {
    background-color: ${(props) => props.theme.palette.background.default};
    border: 2px solid ${(props) => props.theme.colors.positive};
  }
  .toggleBar {
    transition: background-color 0.3s;
    background-color: ${(props) => props.theme.colors.white};
    margin-top: 0;
    margin-left: 0;
    width: ${(props) => props.theme.typography.pxToRem(72)};
    height: ${(props) => props.theme.typography.pxToRem(26)};
    opacity: 1;
    border: 1px solid
      ${(props) => shade(0.1, props.theme.colors.content.border)};
    border-radius: ${(props) => props.theme.typography.pxToRem(16)};
    box-shadow: none;
  }

  && {
    width: ${(props) => props.theme.typography.pxToRem(72)};
    padding: 0;
    align-items: center;
    justify-content: center;
    overflow: hidden;

    .toggleChecked {
      & + .toggleBar {
        opacity: 1;
        background-color: ${(props) => shade(0.1, props.theme.colors.positive)};
        border-color: ${(props) => props.theme.colors.positive};
      }
    }
    .toggleDisabled {
      & + .toggleBar {
        opacity: 1;
        background-color: ${(props) => props.theme.colors.offwhite};
        border-color: ${(props) => props.theme.colors.content.border};
      }
    }
  }
`
ToggleStyled.displayName = 'ToggleStyled'
